// 对象序列化成query,示例：{name:"zhangsan",age:20} => name=zhangsan&age=20
export const querySerialize = (obj: Record<string, any>) =>
  Object.entries(obj)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

// 获取对象格式的sessionStorage,,isSessionStorage是否存sessionStorage
export const getObjTypeStorage = (key: string, isSessionStorage: boolean = false): any => {
  const api = window[isSessionStorage ? 'sessionStorage' : 'localStorage']
  const data = decodeURIComponent(api.getItem(key) || '')
  try {
    return JSON.parse(data)
  } catch (error) {
    console.log('getObjTypeStorageFail', key)
    return {}
  }
}
